// extracted by mini-css-extract-plugin
export default {"main":"WhiteContainer_main__dd0VY","title":"WhiteContainer_title__jW0fC","subtitle":"WhiteContainer_subtitle__USoB1"};